import { render, staticRenderFns } from "./qualification-plan-edit.vue?vue&type=template&id=6131576a&scoped=true"
import script from "./qualification-plan-edit.vue?vue&type=script&lang=js"
export * from "./qualification-plan-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6131576a",
  null
  
)

export default component.exports